module.exports = __webpack_public_path__ + "static/logo-hp-big-4aa02a5139c43372bffaa99396d73321.png";